import React, { useEffect, useState } from "react";
import { PatientQuotesContainerViewModel } from "./PatientQuotesContainerViewModel.csharp";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper";
import { PatientQuoteCard } from "./PatientQuoteCard";
import { PatientQuoteViewModel } from "./PatientQuoteViewModel.csharp";

export const PatientQuotesContainer: React.FC<
  PatientQuotesContainerViewModel
> = ({
  patientQuotes,
  heading,
  ratingIconUrl,
  quoteDetails,
  showAllQuotesLabel,
}) => {
  const breakpoints = {
    0: {
      slidesPerView: 1.2,
    },
    575: {
      slidesPerView: 2.2,
    },
    951: {
      slidesPerView: 4,
    },
  };

  const chunkSize = 4;
  const [quoteChunks, setQuoteChunks] = useState<PatientQuoteViewModel[][]>([]);
  useEffect(() => {
    setQuoteChunks([patientQuotes.slice(0, chunkSize)]);
  }, []);

  const hasMore = patientQuotes.length > chunkSize && quoteChunks.length === 1;

  const showAllQuotes = () => {
    const chunkedArray: PatientQuoteViewModel[][] = [];
    for (let i = 0; i < patientQuotes.length; i += chunkSize) {
      chunkedArray.push(patientQuotes.slice(i, i + chunkSize));
    }
    setQuoteChunks(chunkedArray);
  };

  return patientQuotes.length > 0 ? (
    <section>
      <div className="body-text-container">
        <h2 className="h3 mb-2 mb-md-3">{heading}</h2>
      </div>

      {quoteChunks.map((c) => (
        <div className="mb-5">
          <Swiper
            breakpoints={breakpoints}
            spaceBetween={20}
            modules={[FreeMode]}
            freeMode={{ enabled: true, momentum: true }}
          >
            {c.map((q, index) => (
              <SwiperSlide key={index} className="featuredDoctorSlide">
                <PatientQuoteCard
                  {...q}
                  ratingIconUrl={ratingIconUrl}
                  quoteDetails={quoteDetails}
                />
              </SwiperSlide>
            ))}
          </Swiper>
          {hasMore && (
            <button
              className="btn-link link-list--simple__load-more mt-3"
              onClick={showAllQuotes}
              aria-controls="servicesList"
            >
              {showAllQuotesLabel}
            </button>
          )}
        </div>
      ))}
    </section>
  ) : null;
};
